/**
 * Detección de settings sensibles (credenciales/secretos), alineada con la
 * convención del backend (apps/settings/utils/secrets.py): se identifica por
 * SUFIJO de la clave, no por "contiene KEY" (que marcaría mal KEYCLOAK_URL).
 *
 * El backend enmascara exactamente estas claves; el front debe tratar como
 * secreto lo mismo que el backend enmascara, para que el flujo de edición
 * (preservar / reemplazar) sea coherente.
 */
const SECRET_KEY_SUFFIXES = [
  "_API_KEY",
  "_SECRET",
  "_CLIENT_SECRET",
  "_PASSWORD",
  "_TOKEN",
  "_PRIVATE_KEY",
  "_SECRET_KEY",
];

// Claves con sufijo "secreto" que en realidad son identificadores públicos.
const SECRET_KEY_EXCEPTIONS = ["KEYCLOAK_CLIENT_ID"];

const useSettingsSecrets = () => {
  const isSecretKey = (key) => {
    if (!key) return false;
    const normalized = String(key).trim().toUpperCase();
    if (SECRET_KEY_EXCEPTIONS.includes(normalized)) return false;
    return SECRET_KEY_SUFFIXES.some((suffix) => normalized.endsWith(suffix));
  };

  return { isSecretKey };
};

export default useSettingsSecrets;
